import React from 'react';
import type { TierFormValue } from './types';
import { fieldClass, helperClass, labelClass } from '../styles';

interface TierFormFieldsProps {
  value: TierFormValue;
  onChange: (next: TierFormValue) => void;
  mode: 'create' | 'edit';
  disabled?: boolean;
}

const TierFormFields: React.FC<TierFormFieldsProps> = ({ value, onChange, mode, disabled }) => {
  const set = (patch: Partial<TierFormValue>) => onChange({ ...value, ...patch });
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="md:col-span-2">
        <label className={labelClass}>
          Name <span className="text-red-600">*</span>
        </label>
        <input
          value={value.name}
          disabled={disabled}
          onChange={(e) => set({ name: e.target.value })}
          className={fieldClass}
        />
      </div>
      <div>
        <label className={labelClass}>Max creator accounts</label>
        <input
          value={value.max_creators}
          disabled={disabled}
          onChange={(e) => set({ max_creators: e.target.value })}
          className={fieldClass}
          inputMode="numeric"
        />
        <p className={helperClass}>Leave blank for unlimited.</p>
      </div>
      <div>
        <label className={labelClass}>Max viewer accounts</label>
        <input
          value={value.max_viewers}
          disabled={disabled}
          onChange={(e) => set({ max_viewers: e.target.value })}
          className={fieldClass}
          inputMode="numeric"
        />
        <p className={helperClass}>Leave blank for unlimited.</p>
      </div>
      <div className="md:col-span-2">
        <label className={labelClass}>Starting credit pool</label>
        <input
          value={value.starting_credit_pool}
          disabled={disabled}
          onChange={(e) => set({ starting_credit_pool: e.target.value })}
          className={fieldClass}
          inputMode="decimal"
        />
        <p className={helperClass}>Leave blank for unlimited. Description, max blueprints, and starting token pool stay unlimited.</p>
      </div>
      {mode === 'edit' && (
        <div>
          <label className={labelClass}>Active</label>
          <label className="inline-flex items-center gap-2 text-sm text-[#4A4A4A]">
            <input
              type="checkbox"
              checked={value.is_active}
              disabled={disabled}
              onChange={(e) => set({ is_active: e.target.checked })}
            />
            Tier is active
          </label>
        </div>
      )}
    </div>
  );
};

export default TierFormFields;
